import axiosWrapper from './axiosWrapper';
import { getTimelines } from '../cache/dataClient';
import cacheSync from '../cache/cacheSync';

const timelineService = {
  // Get all timelines for a project (offline-first)
  async getTimelines(projectId, options = {}) {
    const { useCache = true } = options;
    const result = await getTimelines(projectId, { useCache });
    if (result.error && !result.fromCache) {
      return { data: null, error: result.error };
    }

    // Return in format expected by existing code
    return {
      data: { timelines: result.data || [] },
      error: null,
      fromCache: result.fromCache,
    };
  },

  // Get a single timeline by ID
  async getTimelineById(projectId, timelineId) {
    const response = await axiosWrapper({
      method: 'get',
      path: `projects/${projectId}/timelines/${timelineId}`,
    });
    return response;
  },

  // Create a new timeline
  async createTimeline(projectId, timelineData) {
    const response = await axiosWrapper({
      method: 'post',
      path: `projects/${projectId}/timelines`,
      data: timelineData,
    });
    // Update cache after successful creation
    if (!response.error) {
      cacheSync.syncAfterMutation('timelines', response, 'create').catch((err) => {
        console.warn('[timelineService] Error updating cache after create:', err);
      });
    }
    return response;
  },

  // Update an existing timeline
  async updateTimeline(projectId, timelineId, timelineData) {
    const response = await axiosWrapper({
      method: 'put',
      path: `projects/${projectId}/timelines/${timelineId}`,
      data: timelineData,
    });
    // Update cache after successful update
    if (!response.error) {
      cacheSync.syncAfterMutation('timelines', response, 'update').catch((err) => {
        console.warn('[timelineService] Error updating cache after update:', err);
      });
    }
    return response;
  },

  // Delete a timeline
  async deleteTimeline(projectId, timelineId) {
    const response = await axiosWrapper({
      method: 'delete',
      path: `projects/${projectId}/timelines/${timelineId}`,
    });
    // Update cache after successful delete
    if (!response.error) {
      cacheSync.syncAfterMutation('timelines', { id: timelineId }, 'delete').catch((err) => {
        console.warn('[timelineService] Error updating cache after delete:', err);
      });
    }
    return response;
  },
};

export default timelineService;
